@if (isMobile) {
<div
  class="site-option border-bottom d-flex justify-content-center align-items-center flex-shrink-0 p-0"
  [class.h-100]="!accordionPanelRef.open"
  [style.height.%]="!isMobile && height"
>
  <button class="item btn flex-grow-1" (click)="accordionPanelRef.toggleMenu()">
    <epc-brand-org-text-or-logo [site]="site"></epc-brand-org-text-or-logo>
    <fa-icon
      [icon]="['fas', 'angle-right']"
      class="subsite-icon mr-2"
      [rotate]="accordionPanelRef.open ? '90' : '0'"
    ></fa-icon>
  </button>
</div>
<atx-accordion [closeOthers]="true">
  <atx-accordion-panel
    [animate]="true"
    #accordionPanelRef
    [content]="accordionContentRef"
  ></atx-accordion-panel>
  <ng-template #accordionContentRef>
    <epc-brand-org-site
      [id]="site.siteId"
      [sites]="site.subSites"
      [parentBrandOrgSelector]="false"
      (selectSite)="onSelectSiteClick($event); accordionPanelRef.toggleMenu()"
    ></epc-brand-org-site>
  </ng-template>
</atx-accordion>
} @else {
<div
  class="site-option border-bottom d-flex justify-content-center align-items-center flex-shrink-0 p-0 h-100"
>
  <button
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    class="item btn flex-grow-1"
    (mousemove)="setOpenState(true)"
    (mouseleave)="setOpenState(false)"
  >
    <epc-brand-org-text-or-logo [site]="site"></epc-brand-org-text-or-logo>
    <fa-icon
      [icon]="['fas', 'angle-right']"
      class="subsite-icon mr-2"
    ></fa-icon>
  </button>
</div>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="isMobile"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayWidth]="isMobile ? 350 : 400"
  cdkConnectedOverlayBackdropClass="bg-transparent"
  [cdkConnectedOverlayPositions]="isMobile ? mobilePositions : desktopPositions"
  [cdkConnectedOverlayOpen]="selectorOpened$ | async"
  (backdropClick)="setOpenState(false)"
  (detach)="setOpenState(false)"
>
  <div
    class="w-100 site-option subsite shadow-lg ml-1"
    (mouseenter)="setOpenState(true)"
    (mouseleave)="setOpenState(false)"
  >
    <epc-brand-org-site
      @fade
      [id]="site.siteId"
      [sites]="site.subSites"
      [parentBrandOrgSelector]="false"
      (selectSite)="onSelectSiteClick($event)"
    ></epc-brand-org-site>
  </div>
</ng-template>
}
